import { useCallback, useMemo } from 'react';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { IUserPlanState } from '@/creditflowresearch/application/User/UserPlan/types';
import { checkAccessByUserPlan } from '@/creditflowresearch/application/User/access/checkAccessByUserPlan';

export const useUserPlanAccess = (currentPlan: IUserPlanState | null) => {
  const plan = currentPlan?.plan ?? UserPlanType.UNAUTHORIZED;

  const planFlags = useMemo(() => ({
    isUnauthorized: UserPlan.isUnauthorized(plan),
    isStarter: UserPlan.isStarter(plan),
    isPro: UserPlan.isPro(plan),
    isPremium: UserPlan.isPremium(plan),
  }), [plan]);

  const checkAccessByUserPlanLevel = useCallback((requiredPlan: UserPlanType): boolean => {
    return checkAccessByUserPlan(plan, requiredPlan);
  }, [plan]);

  const checkAccessByFeatureFlag = useCallback((feature: UserPlanFeature): boolean => {
    return currentPlan?.features?.includes(feature) ?? false;
  }, [currentPlan?.features]);

  return {
    ...planFlags,
    checkAccessByUserPlan: checkAccessByUserPlanLevel,
    checkAccessByFeature: checkAccessByFeatureFlag,
  };
};
